
import { Component, Prop, Vue } from 'vue-property-decorator';
import UsersInfoTable from './PdfLayouts/UsersInfoTable.vue';
import SummaryTable from './PdfLayouts/SummaryTable.vue';
import EfilingSummaryTable from './PdfLayouts/EfilingSummaryTable.vue';


import CaTable from './PdfLayouts/CaTable.vue';
import CmTable from './PdfLayouts/CmTable.vue';
import EnfrcTable from './PdfLayouts/EnfrcTable.vue';
import FlmTable from './PdfLayouts/FlmTable.vue';
import PoTable from './PdfLayouts/PoTable.vue';
import PpmTable from './PdfLayouts/PpmTable.vue';
import RelocTable from './PdfLayouts/RelocTable.vue';
import RflmTable from './PdfLayouts/RflmTable.vue';
import WrTable from './PdfLayouts/WrTable.vue';

import OtherFormsTable from './PdfLayouts/OtherFormsTable.vue'
import NcdTable from './PdfLayouts/NcdTable.vue';
import NdtTable from './PdfLayouts/NdtTable.vue';


import AffTable from './PdfLayouts/AffTable.vue';
import ApspTable from './PdfLayouts/ApspTable.vue';
import ApsTable from './PdfLayouts/ApsTable.vue';
import CiftTable from './PdfLayouts/CiftTable.vue';
import ConaTable from './PdfLayouts/ConaTable.vue';
import CorTable from './PdfLayouts/CorTable.vue';
import CsvTable from './PdfLayouts/CsvTable.vue';
import EfspTable from './PdfLayouts/EfspTable.vue';
import FfTable from './PdfLayouts/FfTable.vue';
import FsTable from './PdfLayouts/FsTable.vue';
import GaTable from './PdfLayouts/GaTable.vue';
import NlcrTable from './PdfLayouts/NlcrTable.vue';
import NlcTable from './PdfLayouts/NlcTable.vue';
import NlprTable from './PdfLayouts/NlprTable.vue';
import NlpTable from './PdfLayouts/NlpTable.vue';
import NprTable from './PdfLayouts/NprTable.vue';
import NpTable from './PdfLayouts/NpTable.vue';
import OrdTable from './PdfLayouts/OrdTable.vue';
import PaseTable from './PdfLayouts/PaseTable.vue';


import RefTable from './PdfLayouts/RefTable.vue';

import RfsTable from './PdfLayouts/RfsTable.vue';
import RpsTable from './PdfLayouts/RpsTable.vue';
import RqsTable from './PdfLayouts/RqsTable.vue';
import TrisTable from './PdfLayouts/TrisTable.vue';


import {srcFile} from './logo'

import { reportInfoType } from '@/types/Common';

@Component({
    components:{       
        UsersInfoTable,
        SummaryTable, 
        AffTable,
        ApspTable,
        ApsTable,
        CaTable,
        CiftTable,
        CmTable,
        ConaTable,
        CorTable,
        CsvTable,
        EfspTable,
        FfTable,
        EnfrcTable,
        FsTable,        
        FlmTable,  
        GaTable, 
        NcdTable,
        NdtTable,
        NlcrTable,
        NlcTable,
        NlprTable,
        NlpTable,
        NprTable,
        NpTable,
        OrdTable,
        PaseTable,
        PoTable,
        PpmTable,  
        RefTable,
        RelocTable,       
        RflmTable,   
        RfsTable,
        RpsTable,
        RqsTable,
        TrisTable,     
        WrTable,
        EfilingSummaryTable,
        OtherFormsTable,
    }
})
export default class Report extends Vue {

    @Prop({required:true})
    results!: reportInfoType;

    src =""
    mounted(){        
        this.src = srcFile;
    }
 
}
